/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierDeliveryNoteBundle } from '../../models/carrier-delivery-note-bundle';
import { KeyType } from '../../models/key-type';

export interface GetCarrierBundle$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note bundle key
 */
  deliveryNoteBundleKey: KeyType;
}

export function getCarrierBundle(http: HttpClient, rootUrl: string, params: GetCarrierBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNoteBundle>> {
  const rb = new RequestBuilder(rootUrl, getCarrierBundle.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarrierDeliveryNoteBundle>;
    })
  );
}

getCarrierBundle.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-note-bundles/{deliveryNoteBundleKey}';
